import { jsx as _jsx } from "react/jsx-runtime";
import DeviceAssignmentCard from '../Cards/DeviceAssignmentCard';
function DeviceAssignmentView(props) {
    const { contextCustomer, user } = props;
    return _jsx("div", { children: contextCustomer && user && _jsx(DeviceAssignmentCard, { ...props }) });
}
/** @deprecated - No longer used */
export default DeviceAssignmentView;
